import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Route } from '@app/core/route.service';
import { BroadcastMessageComponent } from './broadcast-message.component';

const routes: Routes = Route.withShell([
  { path: 'broadcastMessages', component: BroadcastMessageComponent, data: { title: 'Broadcast Messages' } }
]);

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule],
  declarations: []
})
export class BroadcastMessageRoutingModule { }
